import { TFunction } from 'i18next';
import * as yup from 'yup';

export function yupInitialize(t: TFunction) {
  yup.setLocale({
    mixed: {
      required: ({ path }) => t('registrations.general.errorFieldRequired', { fieldName: `registrations.general.${path}` }),
      oneOf: ({ path }) => t('registrations.general.errorArrayMin', { min: 1, fieldName: `registrations.general.${path}` })
    },
    string: {
      min: ({ min, path }) => t('registrations.general.errorLettersMin', { min: min, fieldName: `registrations.general.${path}` }),
      max: ({ max, path }) => t('registrations.general.errorLettersMax', { max: max, fieldName: `registrations.general.${path}` })
    },
    array: {
      min: ({ min, path }) => t('registrations.general.errorArrayMin', { min: min, fieldName: `registrations.general.${path}` }),
      max: ({ max, path }) => t('registrations.general.errorArrayMax', { max: max, fieldName: `registrations.general.${path}` })
    }
  });
}
